import { ApiProperty } from '@nestjs/swagger';
import { Expose, Type } from 'class-transformer';
import {
  IsNumber,
  IsOptional,
  IsUUID,
  Min,
  ValidateNested,
} from 'class-validator';
import { GeographyPointDto } from '../../common/dto/geography-point.dto';

export class JobPhaseWorkApprovalBatchDto {
  @ApiProperty({
    type: 'string',
    format: 'uuid',
    title: 'ID of Job whose current phase will be approved.',
    required: false,
  })
  @IsOptional()
  @IsUUID()
  @Expose()
  jobId?: string;

  @ApiProperty({
    type: 'string',
    format: 'uuid',
    title: 'ID of Job whose current phase will be approved (legacy field).',
    required: false,
  })
  @IsOptional()
  @IsUUID()
  @Expose()
  id?: string;

  @ApiProperty({
    type: () => GeographyPointDto,
    nullable: true,
    required: false,
    title: 'Approved Geo',
    description: 'GPS location used to approve current job phase in batch.',
  })
  @IsOptional()
  @ValidateNested()
  @Type(() => GeographyPointDto)
  @Expose()
  approvedGeo?: GeographyPointDto | null;

  @ApiProperty({
    type: 'number',
    nullable: true,
    required: false,
    title: 'Approved Geo Accuracy',
    description: 'Accuracy in meters for approved geo in batch.',
  })
  @IsOptional()
  @IsNumber()
  @Min(0)
  @Expose()
  approvedGeoAccuracy?: number | null;
}
